import isNil from 'lodash/isNil';
import type { BaseUrl, ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';

export const getUrl = (baseUrl: BaseUrl, projectKey: ProjectKey, calendarId?: number): string => {
	const defaultUrl = `${baseUrl}/rest/workinghours/1/api/calendar/${projectKey}`;

	if (isNil(calendarId)) {
		return `${defaultUrl}?operation=calendarCreate`;
	}

	return `${defaultUrl}/${calendarId}?operation=calendarUpdate`;
};
